// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "module." + {"239":"data-holidays","628":"drift","979":"swiper"}[chunkId] + ".js?v=" + {"239":"3aaf7ddb30a76a19fccc","628":"14c395e9b459353b2fd5","979":"c9d28819b78b5db1e4b5"}[chunkId] + "";
};